import { render, staticRenderFns } from "./EnquiryList.vue?vue&type=template&id=f4b28216&"
import script from "./EnquiryList.vue?vue&type=script&lang=js&"
export * from "./EnquiryList.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryList.vue?vue&type=style&index=0&id=f4b28216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports